(() => {
  'use strict';
  if (window.thDesignRefreshLoaded) return;
  window.thDesignRefreshLoaded = true;

  function visible(node) {
    return !!node && node.getClientRects().length > 0;
  }
  function closeMenu(restoreFocus) {
    const panel = document.getElementById('th-nav-panel');
    const button = document.querySelector('[data-th-menu-toggle]');
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    button?.setAttribute('aria-expanded', 'false');
    if (restoreFocus && visible(button)) button.focus();
  }
  function measure() {
    const group = document.getElementById('header-group');
    const header = group?.querySelector('header.th-scope');
    if (!header) return;
    const bar = header.firstElementChild;
    const announcementHeight = Math.max(0, header.offsetTop);
    group.style.setProperty('--th-announcement-height', `${announcementHeight}px`);
    document.documentElement.style.setProperty('--th-header-height', `${bar.offsetHeight}px`);
    document.documentElement.style.scrollPaddingTop = `${bar.offsetHeight + 16}px`;
    const toggle = header.querySelector('[data-th-menu-toggle]');
    if (!visible(toggle)) closeMenu(false);
  }
  document.addEventListener('keydown', event => {
    const panel = document.getElementById('th-nav-panel');
    const toggle = document.querySelector('[data-th-menu-toggle]');
    if (event.key === 'Escape' && panel && !panel.hidden &&
        (panel.contains(event.target) || event.target === toggle)) {
      event.preventDefault();
      closeMenu(true);
    }
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const toggle = event.target.closest('[data-th-menu-toggle]');
    if (toggle) {
      requestAnimationFrame(() => {
        const panel = document.getElementById('th-nav-panel');
        if (panel && !panel.hidden) {
          const first = [...panel.querySelectorAll('a[href],button,input,select')]
            .find(node => visible(node) && !node.disabled);
          first?.focus();
        }
      });
    } else if (!event.target.closest('header.th-scope')) {
      closeMenu(false);
    }
  });
  let observer;
  function init() {
    observer?.disconnect();
    const group = document.getElementById('header-group');
    if (group && window.ResizeObserver) {
      observer = new ResizeObserver(measure);
      observer.observe(group);
    }
    measure();
  }
  window.addEventListener('resize', measure, { passive: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => {
    observer?.disconnect();
    queueMicrotask(init);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
